import { render, staticRenderFns } from "./AltImagePicker.vue?vue&type=template&id=33960e02&scoped=true&"
import script from "./AltImagePicker.vue?vue&type=script&lang=js&"
export * from "./AltImagePicker.vue?vue&type=script&lang=js&"
import style0 from "./AltImagePicker.vue?vue&type=style&index=0&id=33960e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33960e02",
  null
  
)

export default component.exports